module.exports = __webpack_public_path__ + "static/media/pdf.c9393328.svg";